package com.tixforgigs.common.core.util

import com.tixforgigs.apax.models.Flavor
import com.tixforgigs.common.core.enums.ClientType
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.core.extensions.tryCatchSentry
import com.tixforgigs.common.http.HttpClient.CLIENT_TYPE
import kotlinx.browser.document
import kotlin.uuid.Uuid

object IdHelper {

  fun generateRandomId(
    length: Int = 10,
    numbersAllowed: Boolean = true,
  ): String {
    val allowedChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
      .plus(if (numbersAllowed) "123456789" else "")
    return (1..length)
      .map { allowedChars.random() }
      .joinToString("")
  }

  val templateId: Uuid
    get() = when (CLIENT_TYPE) {
      ClientType.TEMPLATE_CONFIGURATOR -> Uuid.NIL
      ClientType.ARAI_STOREFRONT -> {
        tryCatchSentry {
          val templateIdInDataAttribute = document.documentElement?.getAttribute("data-id")
          templateIdInDataAttribute?.let { Uuid.parse(it) }
            .orElse { throw IllegalStateException("Template ID not found: $templateIdInDataAttribute") }
        }.getOrElse { Uuid.NIL }
      }
    }

  val flavor: Flavor
    get() = tryCatchSentry {
      val flavorInDataAttribute = document.documentElement?.getAttribute("data-flavor")
      flavorInDataAttribute?.let { plainFlavor -> Flavor.entries.first { it.value == plainFlavor } }
        .orElse { throw IllegalStateException("Flavor not found in Enum (${Flavor::class}): $flavorInDataAttribute") }
    }.getOrElse { Flavor.PROD }

  val apiClientId: String
    get() = tryCatchSentry {
      val idInDataAttribute = document.documentElement?.getAttribute("data-api-client-id")
      idInDataAttribute.orElse { throw IllegalStateException("API client ID not found: $idInDataAttribute") }
    }.getOrElse {
      ToastUtil.showErrorToast("API client ID not found!")
      String()
    }

  val authClientId: String
    get() = tryCatchSentry {
      val idInDataAttribute = document.documentElement?.getAttribute("data-auth-client-id")
      idInDataAttribute.orElse { throw IllegalStateException("AUTH client ID not found: $idInDataAttribute") }
    }.getOrElse {
      ToastUtil.showErrorToast("AUTH client ID not found!")
      String()
    }

  val isEmbedded: Boolean
    get() = document.documentElement?.getAttribute("data-embed")?.toBoolean() ?: false

  val origin: String?
    get() = document.documentElement?.getAttribute("data-origin")
}
